/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Table, ConfigProvider,Space,Tag} from 'antd';
import { hnrequest } from '@/utils'
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const Bfp = () => {
  
  
   const [bangm, setbangm] = useState([]);
  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/p_fprz')
       setbangm(res.rescode)
    }
  
    getau()
  
  }, [])
  
 const columns = [
  
  {
    title: '流水号',
    dataIndex: 'ddno',
    key: 'ddno',
  },
  {
    title: '金额',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '申请时间',
    dataIndex: 'sqtime',
    key: 'sqtime',
  },
  {
    title: '状态',
    dataIndex: 'zt',
    key: 'zt',
     render: (_, record) => (
        <Space size="middle">
          {record.zt === "Y" &&  <Link target="_blank" to={`http://www.ddspp.com/v2/api/dp/?p=${record.ddno}`} ><Tag color="green">已开票</Tag></Link> }
          {record.zt === "N" && <Tag color="blue" >待开票</Tag>}
        </Space>
      ),
  }
];
  

  

 









  const [form] = Form.useForm();
  return (<ConfigProvider locale={zhCN} >

    <div 
    // style={containerStyle} 
    >

      <Form form={form} component={false}>

      <Table size='small' columns={columns} dataSource={bangm} rowKey="ddno"/>

      </Form>


      
    </div>

    
  </ConfigProvider>

  );
};
export default Bfp;